import {
  IMultipleChoiceAnswerView,
  IViewConditionView,
} from 'store/survey/surveyTypes';

export function conditionMatchesAnswer(
  refAnswer: IMultipleChoiceAnswerView | string,
  condition: IViewConditionView
) {
  let valueFound = false;
  if (typeof refAnswer === 'string')
    if (
      condition.questionValues.find((v) => {
        return v === refAnswer;
      })
    )
      return true;
    else return false;
  if (!refAnswer) return false;
  refAnswer.values &&
    refAnswer.values.forEach((it: string) => {
      if (
        condition.questionValues.find((v) => {
          return v === `${it}`;
        })
      )
        valueFound = true;
    });
  refAnswer.selected &&
    refAnswer.selected.forEach((it: number) => {
      if (
        condition.questionValues.find((v) => {
          return v === `${it}`;
        })
      )
        valueFound = true;
    });
  if (
    !valueFound &&
    refAnswer.value &&
    condition.questionValues.find((v) => {
      return v === `${refAnswer.value}`;
    })
  )
    valueFound = true;
  return valueFound;
}
